
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m9.96761 18c-.31482 0-.61822-.1306-.84302-.3676l-4.77882-4.8787c-.46103-.4861-.46103-1.2801 0-1.7657.46103-.4861 1.21406-.4861 1.67458 0l3.91342 3.9662 8.00693-8.54853c.4382-.50973 1.1917-.54538 1.6746-.0713.4834.46204.5172 1.25655.0676 1.76571l-8.8385 9.49712c-.2134.2491-.5282.4028-.85443.4028z","fill":"#4a3428"}})])
          )
        }
      }
    